import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const isActive = ({ isCurrent }) => {
  return isCurrent
    ? { className: "nav-link active" }
    : { className: "nav-link" }
}

const ExactNavLink = props => <Link getProps={isActive} {...props} />

const Footer = ({ siteTitle, footerColor }) => {
  return (
    <footer
      className="pt-5"
      id="footer"
      style={{ backgroundColor: footerColor }}
    >
      <div className="container">
        <div className="row">
          <div className="d-flex justify-content-center justify-content-lg-start col-md-4">
            <Link to="/" className="navbar-brand" href="#">
              <StaticImage
                src="../images/logo-o.png"
                width={67}
                quality={100}
                alt={siteTitle}
                className="img-fluid"
                placeholder="blurred"
              />
            </Link>
          </div>
          <div className="col-md-2  text-center text-md-start mt-4 mt-md-0">
            <h4>About</h4>
            <ul>
              <li>
                <ExactNavLink to="/our-story">Our Story</ExactNavLink>
              </li>
              <li>
                <ExactNavLink to="/the-science">The Science</ExactNavLink>
              </li>
              <li>
                <ExactNavLink to="/how-it-works">How It Works</ExactNavLink>
              </li>
              <li>
                <ExactNavLink to="/pricing">Pricing</ExactNavLink>
              </li>
            </ul>
          </div>
          <div className="col-md-2 text-center text-md-start">
            <h4>Resources</h4>
            <ul>
              <li>
                <a
                  href={`${process.env.HOST_APP}login`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Host Login{" "}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.WEB_APP}auth/login`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Player Login{" "}
                </a>
              </li>
              <li>
                <a
                  href="https://superbetter.zendesk.com/hc/en-us/categories/13026840510363-Frequently-Asked-Questions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  FAQ
                </a>
              </li>
              <li>
                <ExactNavLink to="/terms-and-conditions">
                  Terms & Conditions
                </ExactNavLink>
              </li>
              <li>
                <ExactNavLink to="/privacy-policy">Privacy Policy</ExactNavLink>
              </li>
            </ul>
          </div>
          <div className="col-md-2 text-center text-md-start">
            <h4>Connect</h4>
            <ul>
              <li>
                <ExactNavLink to="/press">Press </ExactNavLink>
              </li>
              <li>
                <ExactNavLink to="/contact">Contact </ExactNavLink>
              </li>
            </ul>
          </div>
          <div className="col-md-2 text-center text-md-start">
            <h4>Play SuperBetter</h4>
            <ul>
              <li>
                <a
                  href="https://apps.apple.com/in/app/superbetter/id536634968"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StaticImage
                    src="../images/apple.png"
                    width={135}
                    quality={100}
                    alt={siteTitle}
                    className="img-fluid"
                    placeholder="blurred"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.superbetter.paid"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <StaticImage
                    src="../images/android.png"
                    width={135}
                    quality={100}
                    alt={siteTitle}
                    className="img-fluid"
                    placeholder="blurred"
                  />
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.WEB_APP}auth/register`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <StaticImage
                    src="../images/superBetter.png"
                    width={135}
                    quality={100}
                    alt={siteTitle}
                    className="img-fluid"
                    placeholder="blurred"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-6 d-flex align-items-center justify-content-center justify-content-md-start ">
            <p className="mb-0 footer-text">
              Copyright © {new Date().getFullYear()} SuperBetter, LLC
            </p>
          </div>
          <div className="col-md-6 d-flex  justify-content-center align-items-center justify-content-md-end align-items-md-end">
            <ul className="d-flex gap-3">
              <li>
                <a
                  href="https://www.instagram.com/playsuperbetter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StaticImage
                    src="../images/instagram-icon.svg"
                    width={42}
                    quality={100}
                    alt={siteTitle}
                    className="img-fluid"
                    placeholder="blurred"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/superbetter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StaticImage
                    src="../images/facebook-logo.svg"
                    width={42}
                    quality={100}
                    alt={siteTitle}
                    className="img-fluid"
                    placeholder="blurred"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/superbetter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StaticImage
                    src="../images/twitter-logo.svg"
                    width={42}
                    quality={100}
                    alt={siteTitle}
                    className="img-fluid"
                    placeholder="blurred"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@playsuperbetter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StaticImage
                    src="../images/tiktok-icon.svg"
                    width={42}
                    quality={100}
                    alt={siteTitle}
                    className="img-fluid"
                    placeholder="blurred"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/superbetter-llc/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StaticImage
                    src="../images/linkedin-logo.svg"
                    width={42}
                    quality={100}
                    alt={siteTitle}
                    className="img-fluid"
                    placeholder="blurred"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  siteTitle: PropTypes.string,
  footerColor: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
  footerColor: "#fff",
}

export default Footer
